import React from 'react';

import styles from './index.module.less';
import defaultPicture from './default-picture.png';
import{addVisitLog, history} from 'libs';
import {observer} from "mobx-react";
import cartStore from "pages/cart/store"
import {message} from 'antd';

const goDetail = (item)=>{
    addVisitLog({
        pageName: '产品详情页',
        fromPageUrl: history.location.pathname,
        pageUrl:`${window.location.origin}/goods/detail?id=${item.id}`,
        eventCode: "ProductDetail",
        eventName: "查看产品详情",
        content: JSON.stringify(item),
    })
    window.open('/goods/detail?id=' + item.id,'_blank')
    }
  //加入购物车
  const handleBuy = (record = {}, isBuy = true) => {
    let eventCode = 'ProductListRent';
    let eventName = '产品列表租';
    if (isBuy) {
      eventCode = 'ProductListSale';
      eventName = '产品列表买';
    }
    addVisitLog({
      pageName: eventName,
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: eventCode,
      eventName: eventName,
    })
    cartStore.addRecord(record.id, isBuy ? record.saleCatalog : record.leaseCatalog ).then(v => true)
  }
const ListTemplate = ({ skuList = [], }) => (

    
  <div className={styles['list-wrapper']}>
    {skuList.map((item, index) => (
      <div
        className={styles['list-content']}
        key={item.skuNo || index}
        onClick={() => goDetail(item)}
      >
        <div className={styles['goods-pic'] + ' font0'}>
          {item?.thumb ? (
            <img src={item.thumb} alt={item.name} />
          ) : (
            <img src={defaultPicture} className={styles.default_img}/>
          )}
          <div className={styles['picture-shadow']}></div>
        </div>
        <div className={styles['goods-name']} title={item.name}>{item.name}</div>
        <div className={styles['goods-brand']} title={item.brand+' | '+item.factoryCode}>
         {item.brand}&nbsp;&nbsp;|&nbsp;&nbsp;{item.factoryCode}
          {/* <span className={styles['brand-line']}>|</span>
          <span className='factoryCode'>{item.factoryCode}</span> */}
        </div>
        <div className={styles['opera-button']}>
          {
            item['leaseAble']?(
              <div className={`${styles['opera-button-common']} ${styles['opera-button-primary']}`}  onClick={v =>{v.stopPropagation(); handleBuy(item, false)}}>租赁</div>
            ):""
          }
          {
            item['saleAble'] ? (
              <div className={`${styles['opera-button-common']} ${styles['opera-button-theme']}`}  onClick={v => {v.stopPropagation();handleBuy(item, true)}}>采购</div>
            ):""
          }
        </div>
      </div>
    ))}
  </div>
);


export default observer(ListTemplate);